<template>
  <section>
    <div class="row">
      <vue-element-loading :active="appLoading" :is-full-screen="true">
        <img src="../../assets/honey.gif" />
      </vue-element-loading>
      <div class="col-12 grid-margin">
        <div class="card" style="min-height: 500px">
          <div class="card-body">
            <h4 class="card-title mx-3">
              APIARY DETAILS &nbsp;
              <!-- {{isAdmin}}{{isSupervisor}}{{isUser}} -->
              <!-- <router-link :to="'/sightingsloc1/' + this.id">
                <span>
                  <i style="color: red !important" class="fa fa-map-marker"></i>
                </span>
              </router-link> -->
            </h4>
            <div class="row pt-4">
              <!-- <div class="col-md-3" style="justify-content: center">
                <div style="justify-content: center" class="row">
                  <output>
                    <img
                      :src="image"
                      v-if="apiaryData.photo"
                      style="width: 150px; height: 150px"
                    />
                    <p v-else>No image...</p>
                  </output>
                </div>
              </div> -->

              <div
                v-if="apiaryData"
                style="justify-content: center"
                class="col-md-12 mx-3"
              >
                <b-row>
                  <b-col>
                    <span class="item_title">Apiary ID</span><br />
                    <span class="item_value" v-if="apiaryData.apiaryid">{{
                      apiaryData.apiaryid
                    }}</span>
                    <span class="item_value" v-else>—</span>
                  </b-col>
                  <b-col>
                    <span class="item_title">Apiary Code</span><br />
                    <span class="item_value" v-if="apiaryData.code">{{
                      apiaryData.code
                    }}</span>
                    <span class="item_value" v-else>—</span>
                  </b-col>
                  <b-col>
                    <span class="item_title">Apiary Number</span><br />
                    <span class="item_value" v-if="apiaryData.clusternum">{{
                      apiaryData.clusternum
                    }}</span>
                    <span class="item_value" v-else>—</span>
                  </b-col>
                  <b-col>
                    <span class="item_title">Apiary Location</span><br />
                    <span class="item_value" v-if="apiaryData.locationname">{{
                      apiaryData.locationname
                    }}</span>
                    <span class="item_value" v-else>—</span>
                  </b-col>
                  <!-- <b-col>
                    <span class="item_title">Colony Count</span><br>
                    <span class="item_value" v-if="apiaryData.colonycount">{{apiaryData.colonycount}}</span>
                    <span class="item_value" v-else>-</span>
                  </b-col> --> </b-row
                ><br />
                <b-row>
                  <b-col v-if="userRole == 'Admin'">
                    <span class="item_title">Apiary Owned By</span><br />
                    <span class="item_value" v-if="apiaryData.user.username">{{
                      apiaryData.user.username
                    }}</span>
                    <span class="item_value" v-else>—</span>
                  </b-col>
                  <b-col v-if="userRole == 'Admin'">
                    <span class="item_title">Contact Number</span><br />
                    <span class="item_value" v-if="apiaryData.user.phone">{{
                      apiaryData.user.phone
                    }}</span>
                    <span class="item_value" style="align: center" v-else
                      >—</span
                    >
                  </b-col>
                  <b-col v-if="userRole == 'Admin'">
                    <span class="item_title">Contact Email</span><br />
                    <span class="item_value" v-if="apiaryData.user.email">{{
                      apiaryData.user.email
                    }}</span>
                    <span class="item_value" v-else>—</span>
                  </b-col>
                  <b-col>
                    <span class="item_title">Is Apiary Full ?</span><br />
                    <span class="item_value" v-if="apiaryData.isfull">Yes</span>
                    <span class="item_value" v-else>No</span>
                  </b-col> </b-row
                ><br />
                <!-- <div v-if="userRole == 'User'" class="pt-3 row col-md-12">
                  <div align="center" class="col-md-3">
                    <router-link
                      style="
                        text-decoration: none;
                        color: black;
                        font-weight: bold;
                      "
                      to="/weatherAdd"
                    >
                      <div
                        style="justify-content: center"
                        class="card shadow-sm p-3 mb-5 bg-white rounded"
                      >
                        <img
                          width="120px"
                          height="120px"
                          src="../../assets/weather.png"
                          alt=""
                        />

                        <h5>Weather Condition</h5>
                      </div>
                    </router-link>
                  </div>
                  <div align="center" class="col-md-3">
                    <router-link
                      v-if="apiaryData._id"
                      style="
                        text-decoration: none;
                        color: black;
                        font-weight: bold;
                      "
                      to="/forageAdd"
                    >
                      <div
                        style="justify-content: center"
                        class="card shadow-sm p-3 mb-5 bg-white rounded"
                      >
                        <img
                          width="120px"
                          height="120px"
                          src="../../assets/forage.png"
                          alt=""
                        />

                        <h5>Forage Observed</h5>
                      </div>
                    </router-link>
                  </div>
                  <div align="center" class="col-md-3">
                    <div
                      style="justify-content: center"
                      class="card shadow-sm p-3 mb-5 bg-white rounded"
                    >
                      <img
                        width="120px"
                        height="120px"
                        src="../../assets/hive.jpg"
                        alt=""
                      />

                      <h5>Hive</h5>
                    </div>
                  </div>
                </div> -->

                <div class="container" v-if="weather.length > 0">
                  <h3 style="font-weight: bold">Weather Condition</h3>
                  <div class="row md-6">
                    <div class="col-lg" v-for="(item, i) in weather" :key="i">
                      <div
                        class="card"
                        style="width: 20rem; justify-content: center top: 100px"
                      >
                        <img
                          src="../../assets/weather.png"
                          class="card-img-top"
                          style="height: 60px; object-fit: contain"
                        />
                        <h5 style="text-align: center">Weather Condition</h5>
                        <div style="padding-top: 20px; padding-bottom: 20px">
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Rain</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span class="item_value" v-if="item.rain"
                                  >yes</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Sunny</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span class="item_value" v-if="item.sunny"
                                  >yes</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Temperature</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span
                                  class="item_value"
                                  v-if="item.temperature"
                                  >{{ item.temperature }}</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Wind</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span class="item_value" v-if="item.wind">{{
                                  item.wind
                                }}</span>
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Wind Speed</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span
                                  class="item_value"
                                  v-if="item.windspeed"
                                  >{{ item.windspeed }}</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-row
                    style="padding-right: 40px"
                    v-if="weather.length >= 3"
                    align-h="end"
                  >
                    <b-button variant="dark" text small @click="weatherinfo(id)"
                      >View More</b-button
                    >
                  </b-row>
                </div>
                <div class="container" v-if="forage.length > 0">
                  <h3 style="font-weight: bold">Forage Observed</h3>
                  <div class="row md-6">
                    <div class="col-lg" v-for="(item, i) in forage" :key="i">
                      <div
                        class="card"
                        style="width: 20rem; justify-content: center top: 100px"
                      >
                        <div v-viewer v-if="item.image" style="display: flex">
                          <img
                            :src="baseURL + item.image"
                            class="card-img-top"
                            style="
                              width: 100%;
                              object-fit: contain;
                              cursor: pointer;
                            "
                            height="100px;"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="../../assets/noimg.jpg"
                            class="card-img-top"
                            style="height: 100px; object-fit: contain"
                          />
                        </div>
                        <h5 style="text-align: center">Forage Observed</h5>
                        <div style="padding-top: 20px; padding-bottom: 20px">
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Crop</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span class="item_value" v-if="item.crop"
                                  >yes</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Shrub</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span class="item_value" v-if="item.shrub"
                                  >yes</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12" md="12">
                            <b-row style="justify-content: center">
                              <b-col md="6" cols="6" sm="6">
                                <span class="item_title">Tree</span>
                              </b-col>
                              <b-col md="3" cols="3" sm="3">
                                <span class="item_value" v-if="item.tree"
                                  >yes</span
                                >
                                <span class="item_value" v-else> No</span>
                              </b-col>
                            </b-row>
                          </b-col>
                        </div>
                      </div>
                    </div>
                  </div>
                  <b-row
                    style="padding-right: 40px"
                    v-if="forage.length >= 3"
                    align-h="end"
                  >
                    <b-button text small variant="dark" @click="forageinfo(id)"
                      >View More</b-button
                    >
                  </b-row>
                </div>
                <div style="padidng-top: 0px !important" class="px-3">
                  <h4 class="pb-3 pl-3">HIVES MAP VIEW</h4>
                  <h6 class="pl-4" v-if="!flag">No Hives found !!</h6>
                  <!-- <div v-if="colonyData.length > 0" id="newMap"></div> -->
                  <div v-if="colonyData.length > 0">
                    <hiveMap v-bind:id="id" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import hiveMap from "./hiveMap";
import store from "../../store";
export default {
  name: "myprofile",
  props: ["id"],
  components: {
    QrcodeVue,
    hiveMap,
  },
  data() {
    return {
      appLoading: false,
      userRole: store.state.userRole,
      apiaryData: {
        user: {},
      },
      weather: [],
      forage: [],
      image: null,
      msg: null,
      colonyData: [],
      events: [],
      flag: false,
      apiary: [
        {
          title: "Weather Conditions",
          value: "weather",
          path: "/weather/",
          src: "weather.png",
        },
        {
          title: "Forage Observed",
          value: "forage",
          path: "/forage/",
          src: "forage.png",
        },
        {
          title: "Hives",
          value: "hives",
          path: "/colonyList/",
          src: "hive.jpg",
        },
      ],
      map: null,
    };
  },
  // computed:{
  // userData(){
  //   if( store.state.isLoggedIn)
  //   return  store.state.userData
  // }
  // },

  mounted: function () {
    this.getview();
    if (this.userRole == "Admin") {
      this.getWeather();
      this.getforage();
    }
  },
  methods: {
    getColonyList() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/colony/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          cluster: this.apiaryData._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.colonyData = response.data.data;
            if (this.colonyData.length > 0) this.flag = true;
            if (this.flag) {
            } else {
              this.msg = "No Data Found !!";
            }
            //        window.myFunction = function (id) {
            //   vm.$router.push("/colonyDetails/" + id);
            // };
            //   for(var i=0;i<5;i++)
            //  {
            //    this.getEventList(this.colonies[i].colonyidentifier)
            // }
            this.appLoading = false;
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((e) => {
          this.appLoading = false;
          //this.errors.push(e);
          this.msg = "failed";
        });
    },
    getWeather() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/cluster/weather/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { cluster: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.appLoading = false;
            var temp = [];
            temp = response.data.data;
            this.appLoading = false;
            if (temp.length > 3) {
              this.weather = temp.slice(0, 3);
            } else {
              this.weather = response.data.data;
            }
            // this.weather = response.data.data;
            // this.getColonyList();
            if (this.weather.photo) {
              this.image = this.baseURL + this.weather.photo;
            }
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((err) => {
          //this.errors.push(err);
          // alert("No Network Found!!");
        });
    },
    getforage() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/cluster/forage/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { cluster: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.appLoading = false;
            var temp = [];
            temp = response.data.data;
            this.appLoading = false;
            if (temp.length > 3) {
              this.forage = temp.slice(0, 3);
            } else {
              this.forage = response.data.data;
            }
            // this.weather = response.data.data;
            // this.getColonyList();
            if (this.forage.photo) {
              this.image = this.baseURL + this.forage.photo;
            }
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((err) => {
          //this.errors.push(err);
          // alert("No Network Found!!");
        });
    },
    getview() {
      this.appLoading = true;
      var url;
      if (this.userRole == "Admin") {
        url = "/cluster/adminget";
      } else {
        url = "/cluster/get";
      }
      axios({
        method: "GET",
        url: url,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.appLoading = false;
            this.apiaryData = response.data.data;
            this.getColonyList();
            if (this.apiaryData.photo) {
              this.image = this.baseURL + this.apiaryData.photo;
            }
          } else if (response.data.status === false) {
            this.appLoading = false;
          }
        })
        .catch((err) => {
          //this.errors.push(err);
          // alert("No Network Found!!");
        });
    },
    weatherinfo(wid) {
      this.$router.push("/weather/" + wid);
    },
    forageinfo(wid) {
      this.$router.push("/forage/" + wid);
    },
  },
};
</script>
<style>
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
/* #newMap {
  height: 500px !important;
  width: 100%;
} */
.card {
  display: block !important;
}
.item_title {
  font-weight: bold;
  font-size: 14px;
}
.item_value {
  font-size: 13px;
}
</style>